import React from 'react';
import styled from 'styled-components';
import theme from '../../styles/theme';

const ProgressContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background-color: ${theme.colors.doryLighterBlue};
  z-index: ${theme.zIndex.sticky};
  overflow: hidden;
`;

const ProgressFill = styled.div`
  height: 100%;
  background: linear-gradient(
    90deg,
    ${theme.colors.doryBlue} 0%,
    ${theme.colors.doryGreen} 100%
  );
  width: ${props => props.$progress}%;
  transition: width ${theme.animation.durations.normal} ${theme.animation.easings.easeOut};
  border-radius: 0 2px 2px 0;
`;

const ProgressText = styled.div`
  position: fixed;
  top: 12px;
  right: ${theme.spacing.md};
  font-family: ${theme.typography.bodyFont};
  font-size: ${theme.typography.sizes.small};
  font-weight: ${theme.typography.weights.medium};
  color: ${theme.colors.textLight};
  z-index: ${theme.zIndex.sticky};
  
  @media screen and (max-width: ${theme.breakpoints.mobileLg}) {
    font-size: ${theme.typography.sizes.tiny};
    top: 8px;
    right: ${theme.spacing.sm};
  }
`;

const ProgressBar = ({ 
  currentProgress = 0, 
  showText = true,
  currentStep = 0,
  totalSteps = 1,
  nextCheckpoint = null 
}) => {
  // Ensure progress is between 0 and 100
  const clampedProgress = Math.max(0, Math.min(100, currentProgress));
  
  const getProgressText = () => {
    if (nextCheckpoint) {
      return `Next: ${nextCheckpoint}`;
    }
    return `${currentStep + 1} of ${totalSteps}`;
  };

  return (
    <>
      <ProgressContainer>
        <ProgressFill $progress={clampedProgress} />
      </ProgressContainer>
      {showText && (
        <ProgressText>
          {getProgressText()}
        </ProgressText>
      )}
    </>
  );
};

export default ProgressBar; 